export default {
  '404': {
    meta: '404 עמוד לא נמצא',
    heading: '404 - עמוד לא נמצא',
    content: 'הדף שחיפשת לא נמצא. אם אתה חושב שדף האינטרנט צריך להיות כאן אנא הודע לנו באמצעות טופס יצירת הקשר בכותרת התחתונה.',
  },
  '500': {
    meta: 'שגיאת שרת',
    heading: 'משהו השתבש.',
    content: 'זה לא היה צריך לקרות. אם הודעת השגיאה נמשכת אנא פנה אלינו באמצעות טופס יצירת הקשר למטה.',
  },
  magidShiur: {
    table: {
      filterByMasechta: 'סנן לפי מסכת',
    },
  },
  otherShiurim: {},
  magidShiurTorah: {},
  homepage: {
    featuredMagidShiur: 'מגידי שיעור מומלצים',
  },
  torahShiurSingle: {
    noteOnShiur: 'הערות לשיעור זה',
    moreShiurimBy: 'עוד שיעורים מאת',
  },
  videoPage: {
    suggestedShiur: 'הצעות לשיעורים ממגיד שיעור זה',
  },
  category: {
    heading: '{{ name }} שיעורים',
  },
  approbations: {
    meta: 'הרשאות והסכמות',
    heading: 'הסכמות',
  },
  resources: {
    meta: 'משאבים על הדף',
    heading: 'משאבים מהתורה',
  },
  about: {
    meta: 'מי אנחנו',
  },
  contact: {
    meta: 'צור קשר',
    address: ' אולימפיה ליין, ווטרברי, קונטיקט 06704 25',
    address1: '25 אולימפיה ליין ווטרברי',
    hotline: '',
    hotlineHeading: '',
    state: 'קונטיקט 06704',
    phone: '203-312-7427',
    phoneLink: '203-312-7427',
    email: 'info@hadafbeiyun.org',
    sendMessage: 'שלח לנו הודעה',
  },
  rss: {
    meta: 'עדכוני rss ופודקאסטים.',
    title: 'RSS עדכון',
    content: 'אתה יכול להירשם לעדכון הראשי שלנו כדי לקבל דף יומי או להירשם לכל מסכת בנפרד',
    heading: 'עדכון ראשי',
  },
  donate: {
    donationType: 'סוג התרומה',
    oneTime: 'חד פעמי',
    selectBillingCycle: 'בחר מחזור חיוב',
    untilNotice: 'עד להודעה חדשה',
    donationAmount: 'סכום התרומה',
    selectAmount: 'נא בחר את סכום התרומה.',
    yourDonation: 'התרומה שלך',
    personalInfo: 'מידע אישי',
    enterFullname: 'אנא הזן שם מלא',
    enterEmail: 'אנא הזן כתובת דואר אלקטרוני תקינה',
    enterAddress1: 'אנא הזן שדה כתובת 1',
    enterCity: 'הזן עיר בבקשה.',
    enterZip: 'אנא הזן מיקוד.',
    enterState: 'אנא הזן מדינה.',
    enterCountry: 'אנא בחר מדינה.',
    sendReciept: 'שלח לי קבלת נייר, בנוסף לקבלה בדואר אלקטרוני.',
    addDedication: 'הוסף הקדשה',
    inMemory: 'לעילוי נשמתלזכר',
    inHonor: 'לכבוד',
    nameOfLovedOne: 'שם האהוב',
    additionalInfo: 'מידע נוסף להקדשה לדוגמא יוםדף מסויים',
    paymentMethod: 'אמצעי תשלום',
    duration: {
      monthly: 'חודשי',
      monthlyUntil: 'חודשי עד להודעה חדשה',
      monthly1Month: 'חודשי לחודש 1',
      monthlyForXMonths: 'חודשי למשך {{ count }} חודשים',
    },
    successCard: {
      heading: 'תודה לך על תרומתך',
      content: 'הודעת דואר אלקטרוני עם פרטי התרומה נשלחה אליך.',
    },
  },
  live: {
    heading: 'שידור חי',
  },
  profile: {
    greeting: 'שלום {{name}}, אתה מחובר כ- {{email}}.',
  },
};
